const TOAST_PREFIX = '@TOAST';

export const SHOW = `${TOAST_PREFIX}/SHOW` as const;
export const HIDE = `${TOAST_PREFIX}/HIDE` as const;
